


























































































































































































































































// import { AxiosResponse } from 'axios'
import { Vue, Component, Watch } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar/index.vue'
import UploadVideo from '@/components/upload-video/index.vue'
import FormItem from '@/components/form-item/index.vue'
import CheckBox from '@/components/check-box/index.vue'
import Mtextarea from '@/components/m-textarea/index.vue'
import SelectItem from '@/components/Select.vue'
import { uploadFrom, uploadChannel } from '@/constants/uploadFrom'
import {
  GetTag,
  PostVideos,
  GetActList,
  GetActTypeList,
} from '@/services/uploads'
import SubmitTransition from '@/components/submit-transition/index.vue'
import Mprotocol from '@/components/m-protocol/index.vue'
import EditorCropper from '@/components/EditorCropper/index.vue' //裁剪模块
import Popup from '@/components/popup/index.vue'

import VideoClassify from './components/VideoClassify.vue'
import NewTag from './components/NewTag.vue'
import relateStar from './components/relateStar.vue'
import relateCli from './components/relateCli.vue'
// import {getActListUrl, getActTypeListUrl} from './urls'
@Component({
  components: {
    HeaderBar,
    UploadVideo,
    Mtextarea,
    FormItem,
    CheckBox,
    SelectItem,
    SubmitTransition,
    Mprotocol,
    EditorCropper,
    Popup,
    relateStar,
    relateCli,
    VideoClassify,
    NewTag,
  },
})
export default class Video extends Vue {
  private title = '发布视频'
  public formData: any = Object.assign({}, uploadFrom)
  channelList: UploadVideoAPI.Channel[] = Object.assign([], uploadChannel)
  coverImgHeng = ''
  coverImgShu = ''
  imgPreview = {
    heng: '', // 正面照
    shu: '', // 反面照
  }
  videoTitle = ''
  planDesc = ''
  actDesc = ''
  statusTxt = '提交成功，等待审核结果'
  isAgree = false
  showSmallLoad = false
  showBigLoad = false
  publishSuccess = false
  submitIng = false
  imgIndex = null
  imgType = ''
  tags: Array<string> = []
  taglList: Array<object> = []

  selectStarArr: Array<any> = []
  showStarPop = false
  showStarLabel: string = ''

  selectCliArr: Array<any> = []
  showCliPop = false
  showCliLabel: string = ''
  showmode: number = 0

  $toast: any
  CropperData = {
    cropperDialogVisible: false,
  }
  showCoverDialog = false
  defaultCover: Array<string> = []

  showActDialog = false
  currentActId = 0
  actTypeList: Array<any> = []
  showActList: Array<any> = []
  selectAct = {}
  uploadTag: Set<string> = new Set()

  get classify() {
    return this.$store.state.uploads.classify
  }

  get planList() {
    return this.$store.state.uploads.planList
  }
  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }
  @Watch('formData.tagCategory')
  watchValue(newval: string) {
    if (newval) {
      this.fetchTag()
    }
  }
  @Watch('formData.planid')
  watchPlan(newval: string | number) {
    const item = this.planList.filter((el: any) => {
      return el.id == newval
    })
    this.planDesc = item[0].desc ? item[0].desc : ''
  }

  @Watch('formData.actid')
  updateShowMode(data: any) {
    console.log('updateShowMode', data)
    this.showmode = data
    this.formData.tagCategory = data.tagCategory
    this.formData.classId = data.classId
  }

  closeStarPop(data: any) {
    this.selectStarArr = data
    this.showStarPop = false
    this.showStarLabel = this.arrToString(data)
  }

  showStar() {
    this.showStarPop = true
  }

  closeCliPop(data: any) {
    this.selectCliArr = data
    this.showCliPop = false
    this.showCliLabel = this.arrToString(data)
  }

  showCli() {
    this.showCliPop = true
  }

  arrToString(data: any) {
    let star = ''
    for (let i = 0; i < data.length; i += 1) {
      star += `${data[i].tagName},`
    }
    return star
  }

  checkVideoFrom(): boolean {
    const {
      typearea,
      // userclassTag,
      video: { vrsId, finsh },
    } = this.formData
    if (!this.videoTitle) {
      return !!0
    }
    let fileCloudId = this.formData.fileCloudId
    if (
      !this.coverImgHeng ||
      !this.coverImgShu ||
      // !classId ||
      // !tagCategory ||
      !typearea ||
      // !userclassTag ||
      !fileCloudId ||
      !finsh
    ) {
      return !!0
    }
    return !!1
  }

  setFormat(): UploadVideoAPI.SaveVideoTypeNew {
    const vUploadLog = this.formData.video.uploadlog
      ? JSON.parse(this.formData.video.uploadlog)
      : {}
    const fileId = vUploadLog.fileId ? vUploadLog.fileId : ''
    const {
      coverImgHeng,
      coverImgShu,
      videoTitle,
      formData: {
        video: { vrsId },
        classId,
        tagCategory,
        typearea,
        fileName,
        fileCloudId,
      },
    } = this

    return {
      videoId: vrsId,
      crossImg: coverImgHeng,
      verticalImg: coverImgShu,
      title: videoTitle,
      classId,
      typeId: typearea[0],
      areaId: typearea[1],
      className: tagCategory,
      fileId: fileId,
      fileName,
      fileCloudId,
    }
  }

  handlePage() {
    this.$router.replace({ path: '/' })
  }

  // eslint-disable-next-line max-statements, complexity
  async handleSubmit() {
    console.log(this.formData)
    if (this.submitIng) return
    if (!this.isAgree) {
      return this.$toast('请同意用户协议')
    }
    if (!this.checkVideoFrom()) {
      return this.$toast('请输入视频信息')
    }
    this.submitIng = true
    const RequestParams = this.setFormat()
    console.log(1111, RequestParams)
    if (this.uploadTag.size > 0) {
      if (this.uploadTag.has('coverImgHeng') && RequestParams.crossImg) {
        let url = new URL(RequestParams.crossImg)
        RequestParams.crossImg = url.pathname
      }
      if (this.uploadTag.has('coverImgShu') && RequestParams.verticalImg) {
        let url = new URL(RequestParams.verticalImg)
        RequestParams.verticalImg = url.pathname
      }
    }
    if (RequestParams) {
      const { code } = await PostVideos(RequestParams)
      if (code == 200) {
        this.uploadTag.clear()
        this.publishSuccess = true
        this.submitIng = false
        this.$toast('视频发布成功')
      } else {
        this.submitIng = false
        this.$toast('视频发布失败')
      }
    }
  }

  async fetchTag() {
    const { data } = await GetTag(this.formData.tagCategory)
    const list: Array<object> = []
    if (data && data.length) {
      for (let i = 0; i < data.length; i++) {
        list.push({
          id: data[i],
          text: data[i],
          disabled: false,
        })
      }
    }
    this.taglList = list
  }

  getImg(e: Event, type: 'heng' | 'shu') {
    const target: HTMLInputElement = e.target as HTMLInputElement
    const files: FileList | null = target.files

    if (files && files.length) {
      const file = files[0]
      const fileMaxSize = 1024 * 5 //最大5M
      const size = file.size / 1024

      if (!/image\/\w+/.test(file.type) || size > fileMaxSize) {
        this.$toast('图片格式文件错误或图片大小大于5M,请重新选择')
        target.value = ''
        return
      }

      this.imgType = type
      type == 'heng' ? (this.showBigLoad = true) : (this.showSmallLoad = true)

      const reader = new FileReader()
      reader.onload = (event: any) => {
        let imgParam = {}
        if (type === 'heng') {
          imgParam = {
            autoCropHeight: 422,
            autoCropWidth: 750,
            fixedNumber: [16, 9],
          }
        } else if (type === 'shu') {
          imgParam = {
            autoCropHeight: 478,
            autoCropWidth: 342,
            fixedNumber: [5, 7],
          }
        }
        this.CropperData = Object.assign(
          this.CropperData,
          {
            imgBase64: event.target.result,
            file: file,
            fixedBox: true,
            cropperDialogVisible: true,
          },
          imgParam
        )
        console.log(this.CropperData)
      }
      this.imgPreview[type] = URL.createObjectURL(file)
      if (file) {
        reader.readAsDataURL(file)
      }
    }
  }

  refresh() {
    const vedioInputs: any = this.$refs.fileInput
    if (vedioInputs && vedioInputs.length) {
      for (const input of vedioInputs) {
        input.value = ''
      }
    }
  }

  cropperFinsh(data: string, key: string, file: any) {
    this.refresh()
    if (data == 'fail') {
      this.CropperData = {
        cropperDialogVisible: false,
      }
      this.showSmallLoad = false
      this.showBigLoad = false
      return
    }
    if (this.imgType == 'heng') {
      this.imgPreview.heng = URL.createObjectURL(file)
      this.coverImgHeng = data
      this.showBigLoad = false
      this.uploadTag.add('coverImgHeng')
    }
    if (this.imgType == 'shu') {
      this.imgPreview.shu = URL.createObjectURL(file)
      this.coverImgShu = data
      this.showSmallLoad = false
      this.uploadTag.add('coverImgShu')
    }
    this.CropperData = {
      cropperDialogVisible: false,
    }
    this.showCoverDialog = false
  }

  getCoverSucc(url: string) {
    this.defaultCover.push(url)
  }

  showCoverOper(type: string) {
    this.showCoverDialog = true
    this.imgType = type
  }

  selectDefaultCover(imgBase64: string) {
    let File = this.dataURLtoFile(imgBase64, 'temp.jpg')
    let reader = new FileReader()
    reader.onload = () => {
      let imgParam = {}
      if (this.imgType === 'heng') {
        imgParam = {
          autoCropHeight: 422,
          autoCropWidth: 750,
          fixedNumber: [16, 9],
        }
      } else if (this.imgType === 'shu') {
        imgParam = {
          autoCropHeight: 478,
          autoCropWidth: 342,
          fixedNumber: [5, 7],
        }
      }
      this.CropperData = Object.assign(
        this.CropperData,
        {
          imgBase64: imgBase64,
          file: File,
          fixedBox: true,
          cropperDialogVisible: true,
        },
        imgParam
      )
    }
    if (File) {
      reader.readAsDataURL(File)
    }
  }

  dataURLtoFile(dataurl: any, filename: any) {
    const num = dataurl.split('.').length - 1
    const dataurlImg = dataurl.split('.')[num]
    return new File([dataurl], filename, {
      type: `image/${dataurlImg}`,
    })
  }
  async getActListReq(type: any) {
    this.currentActId = type
    const { data } = await GetActList({ typeId: type })
    this.showActList = data
  }
  async getActTypeReq() {
    const { data } = await GetActTypeList()
    this.actTypeList = data
    this.currentActId = 0
  }
  selectActItem(item: any) {
    this.showActDialog = false
    this.selectAct = item
    this.formData.actid = item.id
  }
  cancelActive() {
    this.selectAct = {}
    this.formData.actid = ''
  }
  mounted() {
    this.getActListReq('')
    this.getActTypeReq()
    this.$store.dispatch('uploads/fetchVideoTag')
  }
}
